package ru.it_mozaika.sender.js.application.routes

import oldframes.editors.emailTemplateEditorFrame
import oldframes.editors.triggerEditorFrame
import js.core.jso
import react.Props
import react.createElement
import react.router.RouteObject
val editorRoutes = jso<RouteObject> {
    path = "editor"
    children = arrayOf(
        jso {
            path = "trigger/:id"
            element = createElement<Props> {
                triggerEditorFrame {}
            }
        },
        jso {
            path = "email"
            element = createElement<Props> {
                emailTemplateEditorFrame {}
            }
        }
    )
}